import { render, staticRenderFns } from "./SystemFunctionEdit.vue?vue&type=template&id=3354af48&scoped=true"
import script from "./SystemFunctionEdit.vue?vue&type=script&lang=js"
export * from "./SystemFunctionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3354af48",
  null
  
)

export default component.exports